<template lang="pug">
div
  .modal.is-active(v-if="isDialogActivarDesactivar")
    .modal-background(@click="closeDialogActivaDesactiva()")
    .card.width-350
      header.card-header
        p.card-header-title
          span {{formDesactiva.estadoDescripcion}} noticia
      .card-content
        .content
          template
            span.bold ¿Realmente deseas {{formDesactiva.estadoDescripcion}} la noticia
            strong.bold.has-text-primary  &nbsp; {{formDesactiva.titulo}}  &nbsp;
            span ?
      footer.card-footer
        button.button.card-footer-item.is-outlined.info-box-button(@click="closeDialogActivaDesactiva()", :disabled="isloading") Cancelar
        button.button.card-footer-item.info-box-button(@click="fetchActivarDesactivar()", :disabled="isloading", :class="{ 'is-success': formDesactiva.estadoDescripcion === 'Activar', 'is-danger': formDesactiva.estadoDescripcion === 'Desactivar', 'is-loading' : isloading }")
          span {{formDesactiva.estadoDescripcion}}
  .modal.is-active(v-if="showModalAdd")
    .modal-background(@click="closeModalAdd")
    .card.w-750
      header.card-header
        p.card-header-title
          span {{ formulario.id ? 'Editar' : 'Nueva' }} Noticia
      .card-content
        .content
          .form-group.margin-bottom-20
            label.label.is-small.has-text-left Título
            .control
              input.input.is-small(
                type="text"
                v-model="formulario.titulo"
                placeholder="Ingrese el título de la noticia"
                :disabled="isloading"
              )
          .d-flex.form-row.margin-bottom-20
            .flex-1.margin-right-15
              label.label.is-small.has-text-left Descripción
              .control
                textarea.textarea.is-small(
                  rows="5"
                  v-model="formulario.descripcion"
                  placeholder="Ingrese la descripción de la noticia"
                  :disabled="isloading"
                )
            .fecha-vencimiento
              label.label.is-small.has-text-left Fecha Vencimiento
              .control
                input.input.is-small(
                  type="date"
                  v-model="formulario.fechaVencimiento"
                  :disabled="isloading"
                )
          .margin-bottom-20
            label.label.is-small.has-text-left Imagen de la noticia

            input(
              ref="inputFoto"
              type="file"
              accept="image/png,image/jpeg,image/jpg,image/webp"
              style="display: none"
              @change="seleccionarFoto"
            )
            .upload-image(
              v-if="!previewFoto"
              @click="abrirSelectorFoto"
            )
              .upload-image-icon
                i.fa.fa-cloud-upload
              .upload-image-text
                strong Seleccionar imagen
                span Haz clic para adjuntar una fotografía
              span.upload-formats
                | JPG, PNG o WEBP
            .image-preview-container(v-else)
              img.image-preview(
                :src="previewFoto"
                alt="Vista previa de la noticia"
              )
              .image-preview-overlay
                .preview-actions
                  button.button.is-small.is-info(
                    type="button"
                    @click="abrirSelectorFoto"
                    :disabled="isloading"
                  )
                    span.icon.is-small
                      i.fa.fa-camera
                    span Cambiar
                  button.button.is-small.is-danger(
                    type="button"
                    @click="eliminarFoto"
                    :disabled="isloading"
                  )
                    span.icon.is-small
                      i.fa.fa-trash
                    span Eliminar

          .d-flex.justify-content-flex-end.margin-top-20px
            p.control
              button.button.is-small.is-light(
                :disabled="isloading"
                @click="closeModalAdd()"
              )
                span Cancelar

            p.control.margin-left-5
              button.button.is-small.is-success(
                :disabled="isloading"
                @click="fetchGuardar()"
              )
                span.icon.is-small
                  i.fa.fa-save
                span Guardar cambios
  .card
    .card-content
      .d-flex.align-items-center
        .flex.d-flex.jc-center.fd-column
          label.label.is-small.has-text-left Titulo
          input.input.is-small(
            type="text"
            v-model='titulo',
            :disabled='isloading',
            @change="fetch")
        .flex.d-flex.jc-center.fd-column.margin-left-10
          label.label.is-small.has-text-left Estado
          .d-flex.width-100
            .flex-1
              .select.is-small.d-flex
                select.flex-1(v-model='estado', @change="fetch")
                  option(:value="''") Todos
                  option(:value="'1'") Activo
                  option(:value="'0'") Inactivo

        .flex-1.d-flex.justify-content-flex-end
          p.control.margin-left-5
            button.button.is-small.is-success(:disabled='isloading', @click='openModalAdd()')
              span.icon.is-small
                i.fa.fa-plus
              span Nuevo
          p.control.control.margin-left-5
            button.button.is-small.is-primary(:disabled='isloading', @click='fetch()')
              span.icon.is-small
                i.fa.fa-refresh
              span Actualizar
  .card.margin-top-5
    #data-table.position-relative
      .empty-list(v-if="lista.length === 0 && !isloading")
        i.fa.fa-address-card.fa-6x
        .info-message
          span No se encuentran registros para esta búsqueda
      table.table.table.is-full-width.is-responsive(v-if="lista.length !== 0")
        thead
          tr
            th.center-vertical-align-middle.cursor-pointer #
            th.center-vertical-align-middle.cursor-pointer Titulo
            th.center-vertical-align-middle.cursor-pointer Descripcion
            th.center-vertical-align-middle.cursor-pointer Fecha Vencimiento
            th.center-vertical-align-middle.cursor-pointer Modulo
            th.center-vertical-align-middle.cursor-pointer Estado
            th.center-vertical-align-middle.cursor-pointer Accion
        transition-group.table-transition(
          name="fade-smooth",
          tag="tbody" v-show='lista.length !== 0',
          v-infinite-scroll='fetchByScroll',
          infinite-scroll-disabled='disabledScrollExcecute',
          infinite-scroll-distance='2'
          )
          tr( v-for='(item, index) in lista',
            :class="{'bd-desactivado' : !item.estado}"
            :key="`index_${index + 1}`"
          )
            td.center-vertical-align-middle.cursor-pointer
              span {{index + 1}}
            td.center-vertical-align-middle.cursor-pointer
              span {{item.titulo}}
            td.center-vertical-align-middle.cursor-pointer
              span {{item.descripcion}}
            td.center-vertical-align-middle
              strong.has-text-info {{item.fechaVencimiento | formatoFechaText}}
            td.center-vertical-align-middle
              strong.has-text-info {{item.modulo}}
            td.center-vertical-align-middle
              strong.chip.tag(:class="{ 'is-success' : item.estado, 'is-danger' : !item.estado }") {{item.estado ? 'Activo' : 'Inactivo'}}
            td.center-vertical-align-middle
              button.button.is-small.margin-left-5(
                v-if="item.modulo !== 'documentos_importantes'"
                :disabled='isloading || !item.estado',
                @click='editarForm(item)'
              )
                span.icon.is-small
                  i.fa.fa-pencil-square-o
                span Editar
              button.button.is-small.is-danger.margin-left-5(
                :disabled='isloading',
                v-if="item.estado",
                @click='openDialogActivaDesactiva(item)'
              )
                span Desactivar
              button.button.is-small.is-success.margin-left-5(
                :disabled='isloading',
                v-else
                @click='openDialogActivaDesactiva(item)'
              )
                span &nbsp; Activar &nbsp;&nbsp;
      loading-global-sil(v-if="isloading" :message="'Cargando'")
</template>
<script>
import moment from 'moment';
import cargandoLoad                             from '../components/Component_Cargando'
import { apiGet, apiPost, notify, apiUploadWithParams }          from '../util/general.js'
import { mixin as clickaway }                   from 'vue-clickaway';
export default {
  components : {
    'loading-global-sil': cargandoLoad
  },
  mixins: [ clickaway ],
  data () {
    return {
      perfil                : localStorage.getItem('perfil'),
      isloading             : false,
      showModalAdd          : false,
      isDialogActivarFeriado          : false,
      isDialogResetearFeriado          : false,
      lista                 : [],
      isDialogDesactivarFeriado          : false,
      periodos : ['2026', '2027', '2028'],
      periodo : moment().format('YYYY'),
      formulario : {
        titulo      : '',
        descripcion : '',
        fechaVencimiento : moment().add(1, 'week').format('YYYY-MM-DD')
      },
      titulo          : '',
      isScroll                    : false,
      numeroRecnum                : 0,
      noMore                      : false,
      disabledScrollExcecute      : true,
      previewFoto: null,
      isDialogActivarDesactivar   : false,
      tipo                        : '',
      formDesactiva               : {},
      estado                      : ''
    }
  },
  created () {
    var vm = this
    vm.fetch()
  },
  filters: {
    formatoFecha (fecha) {
      return moment(fecha).format('DD/MM/YYYY')
    },
    formatoFechaText (fecha) {
      return moment(fecha).locale('es').format('LL')
    }
  },
  methods: {
    closeModalAdd () {
      var vm              = this
      vm.showModalAdd = false
    },
    openModalAdd () {
      var vm     = this
      vm.formulario.id  = 0
      vm.formulario.titulo  = ''
      vm.formulario.descripcion  = ''
      vm.formulario.foto  = ''
      vm.formulario.fechaVencimiento = moment().add(1, 'week').format('YYYY-MM-DD')
      vm.previewFoto = ''
      vm.showModalAdd = true
    },
    fetchByScroll () {
      this.isScroll = true
      this.fetch()
    },
    fetch () {
      var vm               = this
      vm.isloading         = true

      if (!vm.isScroll) {
        vm.lista        = []
        vm.numeroRecnum = 0
      }
      vm.disabledScrollExcecute = true
      vm.noMore                 = false

      var url         = `/administrador-noticias/obtener`
      var obj = {
        titulo   : vm.titulo,
        estado   : vm.estado,
        numeroRecnum : vm.numeroRecnum
      }
      apiGet(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i])
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExcecute = true
        } else {
          vm.numeroRecnum = data.numeroRecnum
          vm.disabledScrollExcecute = false
        }
      }, function (err) {
        vm.disabledScrollExcecute = true
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isScroll   = false
        vm.isloading  = false
      })
    },
    fetchGuardar () {
      var vm  = this
      if (!vm.formulario.titulo) {
        notify(vm, 'error', 'Error', 'El campo Titulo es obligatorio.')
        return
      }

      if (!vm.formulario.descripcion) {
        notify(vm, 'error', 'Error', 'El campo Descripción es obligatorio.')
        return
      }

      if (!vm.formulario.fechaVencimiento) {
        notify(vm, 'error', 'Error', 'El campo Fecha Vencimiento es obligatorio.')
        return
      }

      var url = '/administrador-noticias/guardar'
      var obj = {
        form: vm.formulario
      }
      apiPost(vm, url, obj, function (data) {
        notify(vm, 'success', 'Exito', 'Los cambios se han guardado correctamente.')
        vm.fetch()
        vm.closeModalAdd()
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isloading = false
      })
    },
    fetchActivarDesactivar () {
      var vm  = this
      var url = '/administrador-noticias/activaDesactiva'
      var obj = {
        form: vm.formDesactiva
      }
      apiPost(vm, url, obj, function (data) {
        notify(vm, 'success', 'Exito', 'Los cambios se han guardado correctamente.')
        vm.fetch()
        vm.closeDialogActivaDesactiva()
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      })
    },
    editarForm (item) {
      var vm              = this
      console.log('item >>>>>', item)
      vm.formulario.id  = item.id
      vm.formulario.fechaVencimiento = moment(item.fechaVencimiento).format('YYYY-MM-DD')
      vm.formulario.titulo      = item.titulo
      vm.formulario.descripcion = item.descripcion
      vm.previewFoto        = item.foto
      vm.formulario.foto        = item.foto
      vm.showModalAdd           = true
    },
    abrirSelectorFoto () {
      this.$refs.inputFoto.click()
    },

    seleccionarFoto (event) {
      var vm = this
      var archivo = event.target.files[0]

      if (!archivo) {
        return
      }

      var tiposPermitidos = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/webp'
      ]

      if (!tiposPermitidos.includes(archivo.type)) {
        notify(
          this,
          'error',
          'Error',
          'Solo se permiten imágenes JPG, PNG o WEBP.'
        )

        event.target.value = ''
        return
      }

      // this.formulario.foto = archivo

      var reader = new FileReader()

      reader.onload = (e) => {
        this.previewFoto = e.target.result
      }
      vm.uploadFile(archivo, function (err, response) {
        console.log('response >>>>>>>>', response)
        if (err) {
          notify(vm, 'error', 'Error', err.message)
        } else {
          vm.formulario.foto = response.file.ruta
          reader.readAsDataURL(archivo)
        }
      })
    },
    eliminarFoto () {
      this.formulario.foto = null
      this.previewFoto = null

      if (this.$refs.inputFoto) {
        this.$refs.inputFoto.value = ''
      }
    },
    uploadFile (file, callback) {
      var vm  = this
      var url = '/upload'
      var fd  = new FormData()
      fd.append('file', file)
      var params = {
        carpeta: 'administrador-noticias',
        usuario: localStorage.getItem('usuario')
      }
      apiUploadWithParams(vm, url, fd, params,
        function (res) {
          callback && callback(null, res)
        },
        function (err) {
          callback && callback(err)
        }
      )
    },
    openDialogActivaDesactiva (item) {
      var vm = this
      vm.formDesactiva                     = item
      vm.formDesactiva.estadoDescripcion   = +item.estado === 0 ? 'Activar' : 'Desactivar'
      vm.isDialogActivarDesactivar         = true
    },
    closeDialogActivaDesactiva () {
      var vm = this
      vm.isDialogActivarDesactivar = false
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "../assets/colors.styl"
.w-350
  width: 350px;
.data-table
  max-height: calc(100vh - 180px);
  min-height: calc(100vh - 180px);
  overflow-y: scroll;
  overflow-x: hidden;
  border-top: 1px solid #d0d4da;

.data-table-full
  max-height: calc(100vh - 180px);
  min-height: calc(100vh - 180px);
  overflow-y: scroll;
  overflow-x: hidden;
  border-top: 1px solid #d0d4da;

table
  font-size: 11px !important

table
  font-size: 11px !important
.width-350
  width: 350px;

.d-flex
  display flex

.bd-desactivado
  background-color: #ff386017 !important

.select-width
  width: 100px

.fd-column
  flex-direction column

.flex-1
  flex 1

.justify-content-flex-end
  justify-content flex-end

.margin-bottom-20
  margin-bottom 20px
table
  font-size: 11px !important
#data-table
  max-height: calc(100vh - 155px)
  min-height: calc(100vh - 155px)
  overflow-y: auto;
  border-top: 1px solid #d0d4da;
td
  cursor pointer

.w-750
  width 750px
  max-width 95vw

.margin-right-15
  margin-right 15px

.fecha-vencimiento
  width 200px

.upload-image
  width 100%
  min-height 150px
  border 2px dashed #d8dce5
  border-radius 8px
  display flex
  flex-direction column
  justify-content center
  align-items center
  cursor pointer
  background #fafbfc
  transition all .2s ease

.upload-image:hover
  border-color #3273dc
  background #f5f8ff

.upload-image-icon
  width 50px
  height 50px
  border-radius 50%
  background #eef3ff
  display flex
  align-items center
  justify-content center
  margin-bottom 10px

.upload-image-icon i
  font-size 24px
  color #3273dc

.upload-image-text
  display flex
  flex-direction column
  align-items center

.upload-image-text strong
  font-size 13px
  color #363636

.upload-image-text span
  font-size 11px
  margin-top 4px
  color #7a7a7a

.upload-formats
  font-size 10px
  color #a0a0a0
  margin-top 8px

.image-preview-container
  width 100%
  height 250px
  position relative
  border-radius 8px
  overflow hidden
  border 1px solid #e5e5e5
  background #f7f7f7

.image-preview
  width 100%
  height 100%
  object-fit cover
  display block

.image-preview-overlay
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  display flex
  align-items flex-end
  justify-content flex-end
  padding 12px
  background linear-gradient(
    to bottom,
    rgba(0,0,0,0) 55%,
    rgba(0,0,0,.55) 100%
  )

.preview-actions
  display flex
  gap 6px

@media screen and (max-width: 700px)
  .form-row
    flex-direction column

  .margin-right-15
    margin-right 0
    margin-bottom 20px

  .fecha-vencimiento
    width 100%

  .image-preview-container
    height 200px
.margin-left-10
  margin-left: 10px;
</style>




// WEBPACK FOOTER //
// View_Administrador_Noticias.vue?78cd3a2c